import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'
import { Heading } from 'blaze-ui/Heading/Heading'
import { ChevronLeft } from 'blaze-ui/icons/24'
import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { RequestAnotherReviewContent } from './RequestAnotherReviewContent'

interface Props {
  request: InformalFeedbackRequest
}

export const RequestAnotherReviewDrawer = ({ request, ...props }: DrawerProps & Props) => {
  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content fullHeight>
          <Drawer.InnerContent isSnappedTop>
            <Drawer.Top>
              <Drawer.Close label="" icon={ChevronLeft} />
              <Drawer.Title asChild>
                <Heading level={5}>Request Another Review</Heading>
              </Drawer.Title>
            </Drawer.Top>
            <Drawer.Container padding="0">
              <RequestAnotherReviewContent request={request} />
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
}
